module.exports = __webpack_public_path__ + "img/8.0f25f1bd.jpg";